import React, { useState } from 'react';
import { GenPage, SegmentControl } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const SpeedNews = () => {
  const t = useT();
  const [count, setCount]       = useState('10');
  const [maxWords, setMaxWords] = useState('20');

  return (
    <GenPage
      title={t('page.speedNews.title')}
      contentType="speedNews"
      description={t('page.speedNews.desc')}
      outputLabel={t('page.speedNews.output')}
      extraOptions={
        <>
          <div className="flex items-center gap-1.5">
            <span className="text-xs text-gray-500 font-medium whitespace-nowrap">{t('label.count')}</span>
            <SegmentControl
              options={['5', '10', '25', '50', '100']}
              value={count}
              onChange={setCount}
            />
          </div>
          <div className="h-5 w-px bg-gray-200 mx-1" />
          <div className="flex items-center gap-1.5">
            <span className="text-xs text-gray-500 font-medium whitespace-nowrap">{t('label.maxWords')}</span>
            <SegmentControl
              options={['15', '20', '30']}
              value={maxWords}
              onChange={setMaxWords}
            />
          </div>
        </>
      }
      extraInstructions={`Number of speed news items: ${count}\nMaximum words per item: ${maxWords}`}
    />
  );
};
